import { Stack } from "@mui/material";
import { useGetCoherenceScoreOverTime, useGetTeamStatistics } from "src/http";
import { StatisticsCard, StatisticWithGraph } from "src/components";
import { useTeamPageLayoutContext } from "src/pages/TeamPages";
import { useBreakpoints } from "src/hooks";

const TeamStatisticsSummary = () => {
  const { isMdUp } = useBreakpoints();
  const { team } = useTeamPageLayoutContext();
  const { isLoading: isLoadingCoherenceData, data: coherenceScoreData } = useGetCoherenceScoreOverTime(
    [team.guid],
    undefined,
    12,
    true,
  );
  const { isLoading: isLoadingStatistics, data: teamStatistics } = useGetTeamStatistics(team.slug);

  return (
    <Stack direction={isMdUp ? "row" : "column"} spacing={isMdUp ? 1 : 0.5}>
      <StatisticsCard
        isLoading={isLoadingCoherenceData}
        data={[
          {
            title: "Team \nCoherence",
            sx: { flex: 1 },
            render: (
              <StatisticWithGraph
                isLoading={isLoadingCoherenceData}
                data={coherenceScoreData?.selectedTeamsCoherenceScores.map((x) => ({
                  dateUtc: x.dateUtc,
                  value: x.coherenceScore,
                }))}
                minYValue={0}
                maxYValue={10}
                formatValue={(value) => value.toFixed(2)}
              />
            ),
          },
          {
            title: "Response \nRate",
            sx: { flex: 1 },
            render: (
              <StatisticWithGraph
                isLoading={isLoadingCoherenceData}
                data={coherenceScoreData?.selectedTeamsCoherenceScores.map((x) => ({
                  dateUtc: x.dateUtc,
                  value: x.responseRate,
                }))}
                minYValue={0}
                maxYValue={100}
                formatValue={(value) => `${value.toFixed(0)}%`}
              />
            ),
          },
        ]}
      />
      <StatisticsCard
        isLoading={isLoadingStatistics}
        sx={{ flex: 1 }}
        data={[
          {
            title: "Active Strategic \nItems",
            value: teamStatistics?.activeActionItemCount ?? 0,
          },
          {
            title: "Strategic Updates \nLast 30 Days",
            value: teamStatistics?.thirtyDayStrategicChangeCount ?? 0,
          },
          {
            title: "Active \nTasks",
            value: teamStatistics?.activeTaskItemCount ?? 0,
          },
          {
            title: "Active \nLoops",
            value: teamStatistics?.activeIssueCount ?? 0,
          },
          {
            title: "Key \nMetrics",
            value: teamStatistics?.metricCount ?? 0,
          },
        ]}
      />
    </Stack>
  );
};

export { TeamStatisticsSummary };
